const { default: axios } = require('axios');

const getRegionName = async () => {
  const { data } = await axios({
    method: 'GET',
    url: '/api/geo/location',
  });

  window.geo = data
  return data?.region_name;
};

export default getRegionName;
